import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {Observable} from 'rxjs';

/**
 * @deprecated Use `CacheService` from
 * `src/app/api/services/cache.service.ts`. This hand-written wrapper
 * predates the generated client, returns `Observable<any>`, and will be
 * removed once all callers have migrated.
 */
@Injectable({
  providedIn: 'root'
})
export class CacheService {

  private apiEndpoint = 'cache';

  constructor(
    private api: ApiService
  ) { }

  clear(): Observable<any>
  {
    this.api.setEndpoint(this.apiEndpoint + '/clear');
    return this.api.POST();
  }

}
